import {useEffect, useState} from "react";
import ApiService from "../../core/service/api-service";
import {t} from "i18next";
import ResponsiveSelect from "../../core/components/ResponsiveSelect";

export default function HospitalGroupSelectBox({onGroupList, ...props}) {
    const [groups, setGroups] = useState([])

    const getGroups = async () => {
        const res = await ApiService.HospitalGroup.GetList();
        if (res.success) {
            setGroups(res.data)
            onGroupList && onGroupList(res.data)
        }
    }

    useEffect(() => {
        getGroups()
    }, [])

    return (
        <ResponsiveSelect
            mode={'multiple'}
            allowClear={true}
            placeholder={t('Hospital Groups')}
            // options dizisi (eskiden Select.Option çocukları): mobil modal seçici listeyi buradan okur.
            options={groups.map(x => ({ value: x.id, label: x.name }))}
            {...props}
        />
    )
}
